module.exports = __webpack_public_path__ + "fonts/Gilroy-Light.f312c92c.eot";